export default {
  namespaced: true,
  state: {
    instance: null,
    key: null,

    locale: 'de',

    mapOptions: {
      isPositionPinned: true,
      isBearingPinned: true,
      isPathVisible: true
    },

    displayOptions: {
      extendedTourInfos: false,
      zoomAutoAdapt: 16,
      drivelaneStorage: 'discard',
      allowManualEvents: false
    },

    mapBearingAdjustment: 0,
    traceRate: 2000, // 2 seconds
    wifiTimeout: 7200000, // 2 hours
    syncRate: 15000, // 15 seconds
    maxBadgeSize: 30, // 15 seconds
    campaignSorting: 'AZ'
  },
  mutations: {
    update (state, newSettings = {}) {
      for (const [key, value] of Object.entries(newSettings)) state[key] = value
    }
  },
  actions: {
    setAuthentication ({ commit }, { instance, key }) {
      return this.$api
        .test(instance, key)
        .then(isValid => {
          if (!isValid) return false

          commit('update', { instance, key })
          this.$api.authenticate(instance, key)
          return true
        })
    }
  }
}
